import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { API_BASE } from "../utils/api";
import { getMyAccountId } from "../utils/config";
import { hasAccountAccess } from "../utils/permissions";
import Unauthorized from "./Unauthorized"; // ajusta la ruta si es necesario
import { useLanguage } from "../context/LanguageContext";
import { FaFilePdf, FaFileCode } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { downloadFile } from "../utils/downloadFile";

export default function Dashboard() {
    const { t, switchLanguage, language } = useLanguage();
    // ✅ user seguro y sin recrearse en cada render
    const [currentUser] = useState(() =>
        JSON.parse(localStorage.getItem("user"))
    );

    const location = useLocation();

    const query = new URLSearchParams(location.search);
    const [lastOrders, setLastOrders] = useState([]);
    const history = useHistory();
    const MYACCOUNT_ID = getMyAccountId();
    const [downloadingId, setDownloadingId] = useState(null);

    const docElectSri = query.get("doc_elect_sri") === "true";

    // =======================
    // Cargar datos al entrar
    // =======================
    useEffect(() => {
        if (!currentUser) return;
        loadLastOrders();
    }, [docElectSri]);
    // =======================
    // 1) Últimos pedidos
    // =======================
    const loadLastOrders = async () => {
        try {
            const response = await fetch(
                `${API_BASE}/orders-ultra/api/ws/list_orders_ecommerce` +
                `?id_customer=${currentUser.idCustomer}` +
                `&id_ship_to=${currentUser.idShipTo}` +
                `&doc_elect_sri=${docElectSri}`
            );

            const data = await response.json();
            setLastOrders(data);
        } catch (err) {
            console.error("Error cargando últimos pedidos", err);
        }
    };

    if (!currentUser)
        return (
            <div className="mt-20 text-center text-gray-600">
                Cargando...
            </div>
        );
    // ✅ ESTA LÍNEA ES OBLIGATORIA
    const hasAccess = hasAccountAccess();
    // ✅ render condicional DESPUÉS de hooks
    if (!hasAccess) {
        return <Unauthorized />;
    }

    return (
        <div className="container mx-auto px-4 py-5 mt-[100px] md:mt-[180px] lg:mt-[100px]">

            {/* BREADCRUMB */}
            <div className="text-sm text-gray-500 mb-6 hidden">
                Home <span className="mx-1">{">"}</span> Dashboard
            </div>

            {/* TÍTULO */}
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
                {docElectSri ? t.menuDocumentsReceived : t.menuOthersDocumentsReceived}
            </h1>

            {/* ====================== */}
            {/* Últimos pedidos */}
            {/* ====================== */}

            <div className="border-b-2 border-gray-300 w-32 mb-5"></div>
            <div className="flex justify-between items-center mb-2">
                <span className="text-sm text-gray-600">
                    {lastOrders.length} Results
                </span>
            </div>
            <div className="space-y-2 max-h-[500px] overflow-y-auto pr-2">

                {/* ENCABEZADOS */}
                <div
                    className="
                        hidden md:grid
                        grid-cols-8
                        px-4 py-3 bg-gray-100 border-b border-gray-300
                        text-gray-700 font-semibold text-sm
                        sticky top-0 z-20
                    "
                >
                    <span className="hidden">Usuario</span>
                    <span>Fecha</span>
                    <span>Documento</span>
                    <span className="text-right">Número</span>
                    <span className="text-center">Orden de Compra</span>
                    <span className="text-right">Total</span>
                    {docElectSri && (
                        <span className="text-right">Impaga</span>

                    )}
                    {docElectSri && (
                        <span className="text-center">Opciones</span>
                    )}
                    <span></span>
                </div>

                {/* SIN PEDIDOS */}
                {lastOrders.length === 0 && (
                    <p className="text-gray-500">No tiene registros...</p>
                )}

                {/* LISTA */}
                {lastOrders.map((o, index) => (
                    <div
                        key={o.orderId}
                        onClick={() => {
                            history.push(`/order-details/${o.orderId}`, { order: o });
                        }}


                        className="
                            bg-white border border-gray-200 rounded-lg p-3 shadow-sm
                            grid grid-cols-1 md:grid-cols-8
                            gap-2 items-center
                            hover:bg-gray-200 hover:shadow-lg transition
                            cursor-pointer
                        "
                    >
                        {/* USUARIO */}
                        <div className="hidden flex items-center gap-3">

                            <span className="text-gray-800 font-medium text-sm">
                                {o.employeeId}
                            </span>
                        </div>

                        {/* FECHA */}
                        <div className="text-gray-700 text-sm">
                            {new Date(o.orderDate).toLocaleDateString("es-ES", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric"
                            })}
                        </div>
                        {/* DOCUMENTO */}
                        <div className="text-gray-700 text-sm">
                            {o.nameDocumento ?? "—"}
                        </div>

                        {/* NÚMERO */}
                        <div className="text-gray-800 text-right font-semibold text-sm">
                            {o.localId !== null && o.issueId !== null &&
                                o.localId.trim() !== "" && o.issueId.trim() !== ""
                                ? `${o.localId.trim()} - ${o.issueId.trim()} - ${o.orderNumber}`
                                : o.orderNumber}
                        </div>

                        {/* ORDEN DE COMPRA */}
                        <div className="text-center text-gray-800 text-sm">
                            {o.invoiceNumber ?? "—"}
                        </div>

                        {/* TOTAL */}
                        <div className="text-right text-sm">
                            ${Number(o.total || 0).toFixed(2)}
                        </div>
                        {/* DUEDATE */}
                        {docElectSri && (
                            <div className="text-right text-sm">
                                {Number(o.duedate || 0) !== 0
                                    ? `$${Number(o.duedate).toFixed(2)}`
                                    : ""}
                            </div>
                        )}

                        {/* OPCIONES */}
                        {docElectSri && (

                            <div
                                className="flex justify-center gap-2"
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* PDF */}
                                <button
                                    disabled={downloadingId === o.orderId}
                                    onClick={async () => {
                                        setDownloadingId(o.orderId);

                                        try {
                                            await downloadFile(
                                                `${API_BASE}/orders-ultra/api/ws/generate_ride_order?order_id=${o.orderId}`,
                                                `${o.autorizacion}.pdf`
                                            );
                                        } finally {
                                            setDownloadingId(null);
                                        }
                                    }}
                                    className={`
                                            flex items-center gap-1.5
                                            px-3 py-2
                                            text-[13px] font-semibold
                                            rounded-md
                                            border
                                            transition
                                            ${downloadingId === o.orderId
                                            ? "bg-red-100 text-red-400 border-red-200 cursor-not-allowed"
                                            : "bg-red-50 text-red-700 border-red-200 hover:bg-red-100 hover:shadow-sm"
                                        }
                                        `}
                                >

                                    {downloadingId === o.orderId ? (
                                        <>
                                            <svg
                                                className="animate-spin h-3 w-3 text-red-500"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    strokeWidth="4"
                                                    fill="none"
                                                />
                                                <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                                                />
                                            </svg>
                                            Descargando…
                                        </>
                                    ) : (
                                        <>
                                            <FaFilePdf className="text-xs" />
                                            PDF
                                        </>
                                    )}
                                </button>


                                {/* XML */}
                                <button
                                    onClick={() =>
                                        downloadFile(
                                            `${API_BASE}/orders-ultra/api/ws/download_xml?claveAcceso=${o.autorizacion}`,
                                            `${o.autorizacion}.xml`
                                        )
                                    }
                                    className="
                                flex items-center gap-1.5
                                ml-2
                                px-3 py-2
                                text-[13px] font-semibold
                                rounded-md
                                bg-blue-50 text-blue-700
                                border border-blue-200
                                hover:bg-blue-100 hover:shadow-sm
                                transition
                                "
                                >
                                    <FaFileCode className="text-xs" />
                                    XML
                                </button>
                            </div>
                        )}



                    </div>
                ))}
            </div>



        </div>
    );
}
